<div class="fixed bottom-5 right-5 flex flex-col gap-2 z-50">
  @for (toast of toastService.notifies(); track toast.id) {
    <div
      class="p-2 px-4 rounded-xl shadow-xl bg-white text-black flex items-center gap-2 w-fit max-w-max border-[1px] border-black/20 animate-fadein transition-all transform"
    >
      @switch (toast.type) {
        @case ('success') {
          <i class="iconify text-[20px] text-green-500" [attr.data-icon]="CheckCircle2"></i>

        }
        @case ('error') {
          <i class="iconify text-[20px] text-red-500" [attr.data-icon]="XCircle"></i>
        }
        @case ('info') {
          <i class="iconify text-[20px] text-blue-500" [attr.data-icon]="InfoIcon"></i>
        }
        @case ('warning') {
          <i class="iconify text-[20px] text-yellow-500" [attr.data-icon]="MessageCircleWarningIcon"></i>
        }
      }

      <span class="font-normal">{{ toast.message }}</span>
      <i class="iconify text-[20px] text-gray-500 cursor-pointer" [attr.data-icon]="XIcon" (click)="toastService.removeToast(toast.id)"></i>
    </div>
  }
</div>
